// plugins/google-analytics.js
// Plugin de Google Analytics con gestión de consentimiento

const GA4_ID = "G-GJTE7DJFF0";
const IS_PRODUCTION =
  typeof location !== "undefined" &&
  location.host === "calidadtelecos.cnmc.gob.es";

// ============================================
// Funciones globales (disponibles inmediatamente)
// ============================================

// Cargar Google Analytics (solo cuando hay consentimiento)
const loadGoogleAnalytics = () => {
  if (!IS_PRODUCTION) {
    return;
  }

  // Evitar carga duplicada
  if (window.gtag) {
    return;
  }

  // Cargar script de GA4
  if (!document.querySelector(`script[src*="gtag/js?id=${GA4_ID}"]`)) {
    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_ID}`;
    document.head.appendChild(script);
  }

  // Configurar GA4
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;

  gtag("js", new Date());
  gtag("config", GA4_ID, {
    page_path: location.pathname,
    page_title: document.title,
    anonymize_ip: true,
    cookie_flags: "SameSite=None;Secure",
  });
};

// Desactivar Google Analytics
const disableGoogleAnalytics = () => {
  if (!IS_PRODUCTION) return;

  window[`ga-disable-${GA4_ID}`] = true;

  // Eliminar cookies de GA
  const cookies = document.cookie.split(";");
  for (const cookie of cookies) {
    const cookieName = cookie.split("=")[0].trim();
    if (cookieName.startsWith("_ga")) {
      document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
      document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.cnmc.gob.es`;
    }
  }
};

// Exponer globalmente INMEDIATAMENTE (antes del install)
if (typeof window !== "undefined") {
  window.loadGoogleAnalytics = loadGoogleAnalytics;
  window.disableGoogleAnalytics = disableGoogleAnalytics;
}

// ============================================
// Plugin Vue
// ============================================

let routerInitialized = false;

export default {
  install(app) {
    // Registrar navegación en SPAs con Vue Router
    const setupRouterTracking = () => {
      if (routerInitialized) return;

      const router = app.config.globalProperties.$router;
      if (router) {
        router.afterEach((to) => {
          if (window.gtag && IS_PRODUCTION) {
            window.gtag("config", GA4_ID, {
              page_path: to.fullPath,
              page_title: document.title,
            });
          }
        });
        routerInitialized = true;
      }
    };

    // Intentar setup inmediato y también después de montar
    setupRouterTracking();

    // Retry después de que la app esté montada
    if (app.config.globalProperties.$router) {
      setupRouterTracking();
    } else {
      // Esperar a que el router esté disponible
      setTimeout(setupRouterTracking, 100);
    }

    // Exponer en la instancia de Vue también
    app.config.globalProperties.$loadGA = loadGoogleAnalytics;
    app.config.globalProperties.$disableGA = disableGoogleAnalytics;
  },
};

// Exportar para uso directo si se necesita
export { loadGoogleAnalytics, disableGoogleAnalytics };
